export default "__VITE_ASSET__0SiUr5H2__"